module.exports = __webpack_public_path__ + "static/media/image-landingpage.11aa78f9.jpg";